import { Controller } from "@hotwired/stimulus"

// Shows the "date you need them by" field only while that is the answer being
// given on a wholesale order.
//
// The field is rendered visible and is hidden here on connect rather than the
// other way round: without JavaScript the admin still sees a field they can
// fill in, and the server clears the date whenever the answer is not by_date,
// so a stale value cannot survive either way.
export default class extends Controller {
  static targets = ["option", "dateField", "dateInput"]
  static values = { showFor: { type: String, default: "by_date" } }

  connect() {
    this.toggle()
  }

  toggle() {
    const selected = this.optionTargets.find((option) => option.checked)
    const wantsDate = selected?.value === this.showForValue

    this.dateFieldTarget.hidden = !wantsDate

    if (this.hasDateInputTarget) {
      // Disabled so a hidden field cannot submit a value, and required while
      // visible so the browser asks before the server has to.
      this.dateInputTarget.disabled = !wantsDate
      this.dateInputTarget.required = wantsDate
    }
  }
}
